import '.b4{position:relative;}.ssr-plugin'
import '.ea{appearance:none;}.ssr-plugin'
import '.au{flex-shrink:0;}.ssr-plugin'
import '.eb{width:1.5rem;}.ssr-plugin'
import '.ec{height:1.5rem;}.ssr-plugin'
import '.hq{border-radius:2.125rem;}.ssr-plugin'
import '.ee{border:2px solid var(--gray-200);}.ssr-plugin'
import '.dd{background:var(--palette-white);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.x{font-style:normal;}.ssr-plugin'
import '.w{font-weight:400;}.ssr-plugin'
import '.dn{user-select:none;}.ssr-plugin'
import '.ab{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useId } from 'react'
import { Icon } from '../icon/Icon'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '../tooltip/Tooltip'

export type RadioButtonProps = {
  selected: boolean
  groupName?: string
  label?: string
  labelPosition?: 'right' | 'left'
  labelSize?: 'medium' | 'small'
  disabled?: boolean
  style?: React.CSSProperties
  onClick: () => void
  tooltipText?: string
}

export const RadioButton = ({
  selected,
  groupName,
  label,
  labelPosition = 'right',
  labelSize = 'medium',
  disabled = false,
  style,
  tooltipText,
  onClick,
}: RadioButtonProps) => {
  const id = useId()
  const handler = () => {
    if (!disabled) {
      onClick()
    }
  }

  const input = (
    <styled.input className="b4 ea au eb ec hq ee dd"
      key="input-label"
      id={id}
      name={groupName || ''}
      checked={selected}
      type="radio"
      disabled={disabled}
      onChange={handler}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        '&:hover': {
          border: '2px solid var(--gray-300)',
        },
        '&:checked': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--brand-primary) 0.25rem)',
          border: '2px solid var(--brand-primary)',
          animation: 'radio-button-checked 0.2s ease-out',
        },
        '&:disabled': {
          background: 'var(--gray-100)',
          border: '2px solid var(--gray-200)',
        },
        '&:checked:disabled': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--palette-blue-100) 0.25rem)',
          border: '2px solid var(--palette-blue-100)',
          animation: 'radio-button-checked 0.2s ease-out',
        },

      }}
    />
  )

  const labelComponent = <styled.div key="radio-label">{label}</styled.div>
  const components = !label
    ? input
    : labelPosition === 'right'
      ? [input, labelComponent]
      : [labelComponent, input]

  return (
    <styled.label className="d a7 x w dn"
      htmlFor={id}
      style={{
        fontSize: labelSize === 'medium' ? '1.5rem' : '1.125rem',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      <div className="d a7 ab">
        {components}
      </div>
      {tooltipText && (
        <styled.span
        onClick={(e: React.MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
        }}>
          <Tooltip content={tooltipText}>
            <Icon 
              icon={faCircleInfo} 
              style={{ 
                color: 'var(--palette-blue-200)',
                '&:hover': { color: 'var(--brand-secondary)' },
                '&:focus-visible': { color: 'var(--brand-secondary)' }, 
              }} 
              size="small"
            />
          </Tooltip>
        </styled.span>
      )}
    </styled.label>
  )
}
